if (window.tailwind) {
    window.tailwind.config = {
    theme: {
       extend: {
          colors: {
             "on-tertiary-fixed-variant": "#003baf",
             "secondary-fixed": "#e2e2e2",
             outline: "#936e69",
             "surface-container-highest": "#e5e2e1",
             "on-surface": "#1c1b1b",
             "cloud-gray": "#F9F9F9",
             "on-secondary-fixed": "#1a1c1c",
             "on-secondary": "#ffffff",
             "secondary-container": "#dcdddd",
             "on-primary-fixed-variant": "#930000",
             "on-background": "#1c1b1b",
             "on-tertiary": "#ffffff",
             "on-secondary-fixed-variant": "#454747",
             primary: "#a30000",
             secondary: "#5d5f5f",
             "on-primary": "#ffffff",
             "primary-container": "#d10000",
             "surface-container-low": "#f6f3f2",
             "inverse-on-surface": "#f3f0ef",
             "inverse-surface": "#313030",
             "on-secondary-container": "#5f6161",
             "primary-fixed": "#ffdad4",
             error: "#ba1a1a",
             "on-primary-container": "#ffdfda",
             "surface-dim": "#dcd9d9",
             "tertiary-container": "#0057f8",
             "surface-container": "#f0edec",
             "outline-variant": "#e8bcb6",
             background: "#fcf9f8",
             "secondary-fixed-dim": "#c6c6c7",
             "tertiary-fixed-dim": "#b6c4ff",
             "tertiary-fixed": "#dce1ff",
             "surface-tint": "#c00000",
             "on-tertiary-fixed": "#00164e",
             "heritage-red": "#A70C1B",
             "ink-black": "#101010",
             "on-tertiary-container": "#e1e5ff",
             "on-error-container": "#93000a",
             "error-container": "#ffdad6",
             "inverse-primary": "#ffb4a8",
             "primary-fixed-dim": "#ffb4a8",
             tertiary: "#0042c2",
             surface: "#fcf9f8",
             "surface-container-lowest": "#ffffff",
             "cotton-white": "#FFFFFF",
             "on-primary-fixed": "#410000",
             "surface-variant": "#e5e2e1",
             "on-error": "#ffffff",
             "on-surface-variant": "#5e3f3a",
             "surface-container-high": "#ebe7e7",
             "surface-bright": "#fcf9f8",
          },
          borderRadius: {
             DEFAULT: "0.25rem",
             lg: "0.5rem",
             xl: "0.75rem",
             full: "9999px",
          },
          spacing: {
             "margin-desktop": "40px",
             base: "8px",
             "margin-mobile": "16px",
             gutter: "24px",
             "container-max": "1280px",
          },
          fontSize: {
             "headline-lg": [
                "32px",
                { lineHeight: "40px", fontWeight: "600" },
             ],
             "display-lg-mobile": [
                "36px",
                {
                   lineHeight: "44px",
                   letterSpacing: "-0.02em",
                   fontWeight: "700",
                },
             ],
             "label-sm": [
                "12px",
                {
                   lineHeight: "16px",
                   letterSpacing: "0.05em",
                   fontWeight: "600",
                },
             ],
             "label-md": [
                "14px",
                {
                   lineHeight: "20px",
                   letterSpacing: "0.01em",
                   fontWeight: "500",
                },
             ],
             "headline-md": [
                "24px",
                { lineHeight: "32px", fontWeight: "600" },
             ],
             "body-md": [
                "16px",
                { lineHeight: "24px", fontWeight: "400" },
             ],
             "display-lg": [
                "48px",
                {
                   lineHeight: "56px",
                   letterSpacing: "-0.02em",
                   fontWeight: "700",
                },
             ],
             "body-lg": [
                "18px",
                { lineHeight: "28px", fontWeight: "400" },
             ],
          },
       },
    },
 };
}

// Micro-interactions and effects
document.querySelectorAll(".group").forEach((card) => {
   card.addEventListener("mouseenter", () => {
      card.classList.add("scale-[1.02]");
   });
   card.addEventListener("mouseleave", () => {
      card.classList.remove("scale-[1.02]");
   });
});

// Sticky Navbar handle
let lastScroll = 0;
const header = document.querySelector("header");
window.addEventListener("scroll", () => {
   const currentScroll = window.pageYOffset;
   if (header) {
      if (currentScroll > 50) {
         header.classList.add("shadow-md");
         header.style.padding = "4px 0";
      } else {
         header.classList.remove("shadow-md");
         header.style.padding = "0";
      }
   }
   lastScroll = currentScroll;
});

// Click-to-play video (Shopify video hoặc YouTube/Vimeo) — không tự động play
document.querySelectorAll("[data-em-video]").forEach((el) => {
   el.addEventListener("click", () => {
      if (el.dataset.played === "true") return;
      const tpl = el.querySelector("template[data-em-video-embed]");
      if (!tpl) return;
      el.dataset.played = "true";
      el.classList.remove("cursor-pointer");
      const embed = tpl.content.cloneNode(true);
      el.innerHTML = "";
      el.appendChild(embed);
      const video = el.querySelector("video");
      if (video) {
         video.play().catch(() => {});
      }
   });
});